module.exports = __webpack_public_path__ + "images/emoji/four_leaf_clover.878ca53230367cee8ef0.png";